import React from 'react';
import { Options } from 'stubben-edge-unified-frontend-react-components';
import SearchResponse from '@/interfaces/SearchResponse.interface';
import {
  IconSearchResualtCompanies,
  IconSearchResualtIndividual,
  IconSearchResualtTasks,
  ShoppingCartIcon,
} from 'stubben-edge-unified-frontend-react-components';

export function transformSearchResultsToOptions(
  results: SearchResponse[]
): Options {
  return results.map((result, index) => {
    let icon: React.ReactNode;

    switch (result.type) {
      case 'company':
        icon = React.createElement(IconSearchResualtCompanies, { size: 18 });
        break;
      case 'individual':
        icon = React.createElement(IconSearchResualtIndividual, { size: 18 });
        break;
      case 'task':
        icon = React.createElement(IconSearchResualtTasks, { size: 18 });
        break;
      case 'product':
        // Use product image if available, otherwise fall back to cart icon
        if (result.product_image?.file_path) {
          icon = React.createElement('img', {
            src: result.product_image.file_path,
            alt: result.name,
            className: 'h-[18px] w-[18px] rounded object-cover'
          });
        } else {
          icon = React.createElement(ShoppingCartIcon, { size: 18 });
        }
        break;
      default:
        icon = undefined;
    }

    const formattedType =
      result?.type?.charAt(0)?.toUpperCase() + result?.type?.slice(1) || '';

    return {
      label: result.name,
      secondaryLabel: formattedType,
      value: `${result.type}-${index}-${result.name}`,
      href: result.url,
      icon: icon
    };
  });
}
